<template>
  <div v-visible-track="'Iframe.ancientDnaHGAndFarmerPageViewed'">
    <div class="hg-farmer" v-if="$store.state.appConfig.windowWidth >= 769">
      <div class="result-container">
        <HgFarmerTopHeader />
        <HgFarmerPopView />
      </div>
      <div class="detail-container">
        <HgFarmerProximity v-if="$store.state.hgFarmerResult.openedHgFarmerDetail.id"/>
      </div>
    </div>

    <div class="hg-farmer-mobile" v-else>
      <template v-if="$store.state.hgFarmerResult.isOpenedHgFarmerDetail">
        <HgFarmerProximity />
      </template>
      <template v-else>
        <HgFarmerTopHeader />
        <HgFarmerPopView />
      </template>
    </div>
  </div>
</template>

<script>
import HgFarmerCalculateWatcher from '@/views/hg-farmer/services/HgFarmerCalculateWatcher'
import HgFarmerTopHeader from './HgFarmerTopHeader.vue';
import HgFarmerPopView from './details/HgFarmerPopView.vue';
import HgFarmerProximity from './details/HgFarmerProximity.vue';

export default {
  components: {
    HgFarmerTopHeader,
    HgFarmerPopView,
    HgFarmerProximity,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  mounted() {
    HgFarmerCalculateWatcher.init();
  }
};
</script>

<style lang="scss" scoped>
.hg-farmer {
  width: 100%;
  display: flex;

  .result-container {
    display: flex;
    flex-direction: column;
    height: 100vh; 
    z-index: 1;
    width: 40%;
  }
  .detail-container {
    width: 60%;
    flex-grow: 1;
    height: auto;
    position: relative;
  }
}
</style>